export default __webpack_public_path__ + "static/media/PILOTLOGO.a149b5c9.png";